import SwitchRoutes from 'lib/SwitchRoutes';

/**
 * Navigation
 *
 * @return {JSX.Element}
 */
const SearchNavigation = (props) => {
  return <SwitchRoutes {...props} saveQuerySearch />;
};

SearchNavigation.displayName = 'SearchNavigation';

export default SearchNavigation;
